/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Copyright (c) 2024, Oracle and/or its affiliates
 */


/**
 * @module utils/version
 */


const version = '2.0.1';

export default version;

// The second argument is not a month. It is `monthIndex` and starts from `0`.
export const releaseDate = new Date( 2024, 10, 28 );

declare global {
	// eslint-disable-next-line no-var
	var ORTL_VERSION: string;
	var ORTL_VERSION_ADDITIONAL: string;
}

/* istanbul ignore next -- @preserve */
if ( globalThis.ORTL_VERSION ) {
	globalThis.ORTL_VERSION_ADDITIONAL = version;
} else {
	globalThis.ORTL_VERSION = version;
}
